/**
 * @file
 * A JavaScript file for the site.
 *
 * @copyright Copyright 2018 Palantir.net
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

(function ($) {
  'use strict';

  // Use behaviors with context variable.
  Drupal.behaviors.railFilters = {
    attach: function(context) {

      // Show/hide rail filters class based on viewport
      $(window).on('resize load reload', function() {
        if ( $(window).width() < 900 ) {
          $('.rail-filters--trigger, .rail-filters__form').addClass('is-close');
        } else {
          $('.rail-filters--trigger, .rail-filters__form').removeClass('is-close');
        }
      });

      // Rail filters.
      $(once('railFilters', '.rail-filters--trigger', context)).each(
        function() {
          $(this).on('click', function() {
            if ($(this).hasClass('is-close')) {
              $(this).removeClass('is-close');
              $('.rail-filters__form').removeClass('is-close');
            } else {
              $(this).addClass('is-close');
              $('.rail-filters__form').addClass('is-close');
            }
          })
        }
      )
    }
  };

})(jQuery, Drupal, once);
